import type {ReactNode} from 'react';
import {CurrentAccountProvider} from 'components/CurrentAccount';
import LoadingSpinner from 'components/LoadingSpinner';
import {DmDriverOptInStatus} from 'services/graphql/types';
import {useAuth} from 'services/auth';
import SmartBanner from 'react-smartbanner';
import ComplianceModal from '../ComplianceModal';

import 'react-smartbanner/dist/main.css';

interface CurrentAccountProviderWithQueryProps {
  redirect: boolean;
  children: ReactNode;
}

const CurrentAccountProviderWithQuery = ({
  redirect,
  children,
}: CurrentAccountProviderWithQueryProps) => {
  const authQueryResult = useAuth({isAuthRequired: redirect});

  if (authQueryResult.isLoading) {
    return <LoadingSpinner />;
  }

  const currentAccountId = authQueryResult.identity?.id ?? '';
  const currentAccountPhone = authQueryResult.identity?.phone ?? '';

  const isComplianceModalOpen =
    !!authQueryResult.identity &&
    authQueryResult.identity.smsOptInStatus !== DmDriverOptInStatus.OptedIn;

  return (
    <CurrentAccountProvider id={currentAccountId}>
      <SmartBanner daysHidden={1} daysReminder={1} ignoreIosVersion title="ezManage - Delivery" />
      {isComplianceModalOpen && (
        <ComplianceModal phone={currentAccountPhone} driverId={currentAccountId} />
      )}
      {children}
    </CurrentAccountProvider>
  );
};

export default CurrentAccountProviderWithQuery;
